import { isMercoSulExcludingBrazil } from '@src/common/auth';
import { FOREIGN_IDENTITY_TYPE, type Alpha3Code, type ForeignIdentityType } from '@src/domains/customers/types/auth';

/**
 * Document type for a foreign nationality: Mercosur (except Brazil) uses a national
 * id, every other nationality uses a passport. Brazil is not a foreign nationality —
 * Brazilian buyers go through the domestic CPF flow — so it is out of scope here.
 */
export function resolveForeignIdentityType(nationality: Alpha3Code): ForeignIdentityType {
  return isMercoSulExcludingBrazil(nationality) ? FOREIGN_IDENTITY_TYPE.IDENTITY : FOREIGN_IDENTITY_TYPE.PASSPORT;
}
